import React, {useMemo, useRef, useState} from 'react'
import Form from "../../../components/form/Form";
import ReactDOM from "react-dom";
import DocumentRow from "../../../components/DocumentRow";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import MultiFileUpload from "../../../components/form/MultiFileUpload";
import Opportunity from "../../../models/Opportunity";
import AgencyOpportunity from "../../../models/AgencyOpportunity";
import UserImageCircle from "../../../components/UserImageCircle";
import {useMount} from "react-use";

const OppSignedContract = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const formRef = useRef(null);
    const [formModel, setFormModel] = useState({});
    const {
        onRequest,
        onUpdate,
        opportunity,
        changeProps,
        isDisabled
    } = useOpportunity();

    const winningOpportunity = useMemo(() => opportunity.winningResource(), [opportunity, isDisabled]);


    useMount(() => {
        TB.alert('confirm', 'Contract Available', 'Your talent resource was selected to fill this job. Download and review the contract terms and upload a signed copy to accept this project.')
    })
    const job = useMemo(() => {
        return winningOpportunity.relatedJob()
    }, [winningOpportunity])

    const validateSignature = () => {
        if (!formRef?.current) {
            return false
        }
        let invalid = formRef.current.forceValidate();

        if (invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return !invalid;
    }

    const signContract = async () => {

        if (opportunity.winningResource().latest_signed_contract) {

            let success = await onUpdate({
                signed_contract_at: new Date()
            });

            if (success) {
                if (opportunity.winningResource().hasSignedContract()) {
                    await TB.sysAlert('talent.opportunity_active');
                }
            }
        }

    }

    const deleteDocument = async (doc) => {
        let confirmDelete = await TB.sysAlert("talent.delete_proposal_slide_button_clicked");


        if (confirmDelete) {
            let success = await opportunity.winningResource().deleteDocument(doc, 'latest_signed_contract');
        }
    }

    const onFileUploaded = (response, file) => {

        if (!TB.has(response, 'success.data.document')) {
            return;
        }

        let talentOpp = {...winningOpportunity};

        talentOpp.latest_signed_contract = {...response.success.data.document};

        if (file.remove) {
            file.remove();
        }

        let matching_talent = TB.map(opportunity.matching_talent, talentUserOpp => {
            if (talentUserOpp.id === talentOpp.id) {
                return Opportunity.make({...talentUserOpp, ...talentOpp})
            }
            return talentUserOpp;
        })
        changeProps(AgencyOpportunity.make({...opportunity, matching_talent}))
    }

    const onFileChange = async (path) => {

        let FileChangeRequest = TB.request(`/api/talent-user-opportunities/${winningOpportunity.id}/documents/create`, {
            name: path.name,
            path,
            type: TB.invert(laravel.document_types)['Talent Signed Contract']
        });

        FileChangeRequest = FileChangeRequest.headers({
            'Content-Type': 'multipart/form-data'
        })
        let response = await FileChangeRequest.post().catch(console.warn);

        await onFileUploaded(response, path);

        await TB.sysAlert('talent.opp_uploaded_signed_contract_success');
    }
    return (
        <React.Fragment>
            <div className="bg-white w-full">
                <div className="basis-[78%] max-w-[1200px] flex-0 m-auto py-6">

                    <div className="flex justify-start mb-2">
                        <div>
                            <p>Project name</p>
                            <p className="text-xl">{opportunity.project?.name}</p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-5 items-stretch">
                        <div className="flex flex-col md:flex-row md:flex-wrap gap-3 sm:gap-5 items-stretch xs:items-start">
                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Position
                                    </p>
                                    <p>{opportunity.project_position?.title}</p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Location
                                    </p>
                                    <p>{opportunity.project.location ? `${opportunity.project.location?.city}, ${opportunity.project.location?.state}` : <span className="text-danger">Remote</span>}</p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap mb-1.5">
                                        Wripple Roles
                                    </p>
                                    {opportunity.project_position.disciplines?.length > 0 ?
                                        TB.map(opportunity.project_position.disciplines, discipline => (
                                            <p className="font-medium text-secondary "
                                               key={discipline.name}>{discipline.name}</p>
                                        )) : (
                                            <p>N/A</p>
                                        )}
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Brief Status
                                    </p>
                                    <div className="mt-1 flex flex-row gap-1.5 items-center justify-start">
                                        {opportunity.status === 'Lost' ? (
                                            <p className="inline text-xs rounded-full bg-danger py-1 px-3 text-white">{opportunity.display_status}</p>
                                        ) : !opportunity.isAccepted() ? (
                                            <p className="inline text-xs rounded-full bg-warning py-1 px-3">Review
                                                Brief</p>
                                        ) : (
                                            <p className="inline text-xs rounded-full bg-wrippleSuccessLight py-1 px-3">Brief
                                                Accepted</p>
                                        )
                                        }
                                        {opportunity.isAvailable() && (
                                            <Link to={'review-project-brief'} className="btn-link btn-link-info">
                                                Review
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="supplier-portal-container pb-6 flex-col items-stretch">
                <div className="talent-portal-page-container talent-opportunity-container container mx-auto px-8 py-4 mt-6">

                    <div className="flex flex-col self-stretch items-stretch bg-white px-8 py-5 gap-3">

                        <div>
                            <p className="text-lg font-semibold">
                                Selected Talent Resource
                            </p>
                            <p className="text-sm">
                                Congrats, your talent resource has been selected for this project! Review the information below and download the proposed contract below.
                                Once you are satisfied with the terms, upload a signed copy and submit the form
                            </p>
                        </div>
                        <hr/>
                        <div className="flex-grow flex flex-col md:flex-row md:flex-wrap gap-3 sm:gap-5 items-stretch xs:items-start">
                            <div className="flex flex-row items-center gap-2 flex-[1.5]">
                                <UserImageCircle size={50} user={winningOpportunity.user}/>
                                <div className="flex flex-col items-start flex-grow overflow-hidden">
                                    <p className="text-lg font-semibold whitespace-nowrap ellipsis overflow-hidden">
                                        {winningOpportunity.user.fullName()}
                                    </p>
                                    <p className="text-xs">
                                        <span className="text-wripplePrimaryDarkNavy font-semibold">
                                            {`Matched ${TB.pluralize("Role", winningOpportunity.disciplines?.length || 1)}: `}
                                        </span>
                                        {TB.map(winningOpportunity.disciplines || [], (discipline, index) => (
                                            <React.Fragment>
                                                <span className="text-secondary font-semibold" key={discipline.id}>
                                                    {discipline.name}
                                                </span>
                                                {index < winningOpportunity.disciplines?.length - 1 && ", "}
                                            </React.Fragment>
                                        ))}
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">

                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Proposed Hourly Rate
                                    </p>
                                    <p>{TB.formatCurrency(parseFloat(winningOpportunity.job_candidate?.hourly_rate))}/hr</p>

                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Timeline
                                    </p>
                                    <p>{winningOpportunity.panelTimeDisplay()}</p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-3 flex-1">

                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Total Est. Hours
                                    </p>
                                    <p>{parseInt(opportunity.project_position?.total_hours)} hours</p>

                                </div>
                            </div>



                            <div className="flex flex-col gap-3 flex-1">
                                <div>
                                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                                        Est. Payout
                                    </p>
                                    <p>{TB.formatCurrency(opportunity.project_position?.estimated_payout, false)}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="talent-project-contracts-panel">

                        <div className="flex flex-col items-center gap-4">
                            <div className="flex-1">
                                <div className="panel-header text-left">
                                    Contract
                                </div>
                                <div className='talent-project-proposal-container'>
                                    <DocumentRow
                                        document={opportunity.winningResource().latestContract()}
                                        type="PDF"
                                        emptyMessage={"No Contract Yet"}
                                    />
                                </div>
                            </div>

                            <hr/>

                            <div className="talent-opp-contract-container self-stretch">
                                <Form
                                    minimal
                                    ref={formRef}
                                    className="talent-opp-contract-form"
                                    onSubmit={console.warn}
                                    submitButton={false}
                                    background="transparent"
                                    isDisabled={isDisabled}
                                    model={formModel}
                                    onChange={setFormModel}
                                    fields={[]}/>

                                <div className="panel-header">
                                    Upload Signed Contract
                                </div>
                                <MultiFileUpload
                                    multiple={false}
                                    uploadParams={{
                                        url: `/api/talent-user-opportunities/${winningOpportunity.id}/documents/create`,
                                        fields: {
                                            type: TB.invert(laravel.document_types)['Talent Signed Contract']
                                        }
                                    }}
                                    onFileUploaded={onFileUploaded}
                                />
                                {winningOpportunity.latestSignedContract() && (
                                    <div className='talent-documents-container'>
                                        <DocumentRow
                                            document={winningOpportunity.latest_signed_contract}
                                            onDelete={winningOpportunity.isPendingContract() ? () => deleteDocument(winningOpportunity.latest_signed_contract) : undefined}
                                            onUpdate={winningOpportunity.isPendingContract() ? onFileChange : undefined}
                                            disabled={isDisabled}
                                        />
                                    </div>
                                )}


                                <div className="self-end ml-auto">
                                    <button
                                        type="button"
                                        disabled={isDisabled || (!
                                                opportunity.winningResource()?.latest_signed_contract
                                            && !formModel.contract_upload
                                        )}
                                        onClick={signContract}
                                        className="btn btn-primary mr-2">
                                        Finish
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export {
    OppSignedContract
}